module.exports = require('dynamic-module-registry');